<div class='sub-menu'>
  <ul class="left">
    @for (tab of tabs; track tab) {
      <li (click)="changeTab(tab)" matRipple [ngClass]="{'selected': selectedTab === tab}"
        [matTooltip]="getTabTooltip(tab) | translate"
        matTooltipPosition="right">
        <i class="icon {{getTabIcon(tab)}}">
          @if (tab === 'notes' && getTabBadgeInfo(tab) > 0) {
            <span matBadge="{{getTabBadgeInfo(tab)}}"
            matBadgeColor="warn" matBadgeSize="small"></span>
          }
        </i>
      </li>
    }
  </ul>
</div>